import { Component, Input } from "@angular/core";
import { Link } from "@common/ADAPT.Common.Model/organisation/link";
import { AdaptCommonDialogService } from "@common/ux/adapt-common-dialog/adapt-common-dialog.service";
import { IConfirmationDialogData } from "@common/ux/adapt-common-dialog/confirmation-dialog.component/confirmation-dialog.component";
import { BaseComponent } from "@common/ux/base.component/base.component";
import { filter, switchMap } from "rxjs";
import { MeetingsService } from "../meetings.service";

@Component({
    selector: "adapt-display-meeting-objective-link",
    templateUrl: "./display-meeting-objective-link.component.html",
    styleUrl: "../meeting-styles.scss",
    standalone: false,
})
export class DisplayMeetingObjectiveLinkComponent extends BaseComponent {
    @Input() public showDeleteLink = false;
    @Input() public link!: Link;

    public constructor(
        private meetingsService: MeetingsService,
        private commonDialogService: AdaptCommonDialogService,
    ) {
        super();
    }

    public deleteObjectiveLink(link: Link) {
        const confirmationDialogData: IConfirmationDialogData = {
            title: `Delete objective link`,
            message: `<p>Are you sure you want to delete this objective link?</p>
                <p>Note that only the link will be deleted but not the actual objective.</p>`,
            confirmButtonText: "Delete",
            cancelButtonText: "Cancel",
        };

        return this.commonDialogService.openConfirmationDialogWithBoolean(confirmationDialogData).pipe(
            filter((confirmDelete) => !!confirmDelete),
            switchMap(() => this.meetingsService.remove(link)),
            switchMap(() => this.meetingsService.saveEntities([link])),
            this.takeUntilDestroyed(),
        ).subscribe();
    }
}
